import edit from '../_images/edit.svg'
import add from '../_images/add.png'
import back from '../_images/back.svg'
import cross from '../_images/cross.svg'
import settings from '../_images/settings.png'
import cup from '../_images/cup.png'
import verified from '../_images/verified.png'

export default {
  edit,
  add,
  cross,
  back,
  cup,
  settings,
  verified
}
